<template>
  <div id="serp" class="serp">
    <TopMenu ref="topMenu" @showFilter="$refs.tours.showFilter()" />

    <Tours ref="tours" />

  </div>
</template>

<script>
import TopMenu from "./components/top-menu.vue";
import Tours from "./components/tours";
import {mapMutations} from "vuex";

export default {
  name: "serp",
  components: {
    TopMenu,
    Tours,
  },
  methods: {
    ...mapMutations({
      setUser: "user/setUser",
    }),
  },
  mounted() {
    fakeWindow.addEventListener("Auth::data", (e) => {
      if (e.detail.user.isLoggedIn) {
        this.setUser(e.detail.user);
      }
    });

    fakeWindow.addEventListener("Auth::user", (e) => {
      if (e.detail) {
        this.setUser(e.detail);
      }
    });

    fakeWindow.addEventListener("header::show", (e) => {
      this.showHeader = e.detail;
    });
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/global.scss";
@use "@/assets/scss/font-sf-pro.scss";
@use "@/assets/scss/libraries/elements/date-selector-new.scss";

* {
  @include mixins.header();
}

.serp {
  position: relative;
  width: 100%;

  &__loader {
    position: fixed;
    top: 50%;
    margin: 5% auto;
    left: 0;
    right: 0;
  }

  & * {
    font-family: "SF Pro Text";
    font-style: normal;
  }

  &-photo-background {
    --serp-photo-background-height: 254px;

    @include mixin.decor();
    display: block;
    height: 0;

    @include mixin.size-md-min {
      --serp-photo-background-height: 303px;
    }

    &:empty {
      --serp-photo-background-height: 0 !important;
    }

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      height: var(--serp-photo-background-height);
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4));

      @include mixin.size-md-min {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.64) 1.86%, rgba(0, 0, 0, 0.56) 34.37%, rgba(0, 0, 0, 0.56) 57.81%, rgba(0, 0, 0, 0.24) 100%);
      }
    }

    > img {
      filter: none;
      height: var(--serp-photo-background-height);
    }
  }
}
</style>
